/**
 * Z-INDEX MANAGEMENT SYSTEM
 *
 * This file defines standardized z-index values throughout the application.
 * Always import these constants instead of using hardcoded values.
 *
 * Guidelines:
 * - Values are in increments of 100 to allow for intermediate values when needed
 * - Higher values appear on top of lower values
 * - Group related UI elements within the same range where possible
 */

// Base level elements
export const Z_INDEX = {
  // Background elements (0-90)
  BACKGROUND: 0,
  MAP: 10,

  // Base UI elements (100-490)
  DEFAULT: 100, // Default for positioned elements with no explicit z-index
  CONTENT: 200, // Main content elements
  NAVIGATION: 300, // Navigation bars, menus
  STICKY_ELEMENTS: 400, // Sticky headers, footers

  // Floating UI elements (500-890)
  DROPDOWN: 500, // Dropdown menus, select options
  BOTTOM_SHEET: 600, // Mobile bottom sheets
  TOOLTIP: 700, // Tooltips
  POPOVER: 800, // Popovers, floating panels

  // Overlay elements (900-1290)
  OVERLAY: 900, // Page overlays, backdrops
  DRAWER: 1000, // Side drawers
  MODAL: 1100, // Standard modals
  DIALOG: 1200, // Important dialogs

  // Critical UI elements (1300-1490)
  NOTIFICATION: 1300, // Notifications, toasts
  ALERT: 1400, // Critical alerts

  // Top level (1500+)
  LOADING: 1500, // Global loading indicators
  DEV_TOOLS: 9000, // Development tools
  MAXIMUM: 9999 // Absolute maximum (use sparingly)
};
